import axios from "axios";
import React, { useState } from "react";
import { discountGroupObjects } from "./data";
import { GlobalState } from "context/GlobalContext";
import ApplicableDate from "./ApplicableDateSection/ApplicableDate";
import DiscountValueSection from "./DiscountValueSection/DiscountValueSection";
import { Box, Button, Stack, Step, StepLabel, Stepper, Typography } from "@mui/material";
import MasterGeneralInformation from "./MasterGeneralInformation/MasterGeneralInformation";
import ProductSelectionSection from "./ProductSelectionSection/ProductSelectionSection";
import StoreAvailabilitySection from "./StoreAvailabilitySection/StoreAvailabilitySection";

const steps = ["General Information", "Applicable Date", "Store Availability", "Discount Value", "Product Selection"];

function DiscountMaster() {
	const initial_state = {
		[discountGroupObjects.general_information.key]: {
			scheme_type: "",
			scheme_name: "",
			brand: "",
			scheme_description: "",
		},
		[discountGroupObjects.applicable_date.key]: {
			start_date: "",
			end_date: "",
			applicable_days: [],
		},
		[discountGroupObjects.store_availability.key]: {
			region: [],
			store: [],
			distributer: [],
			state: [],
			city: [],
		},
		[discountGroupObjects.discount_value.key]: [],
		[discountGroupObjects.product_selection.key]: {
			discount_product: [],
			nod: [],
		},
	};
	const [value, setValue] = useState(initial_state);
	const [activeStep, setActiveStep] = useState(0);
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

	const handleNext = () => setActiveStep((prev) => prev + 1);
	const handleBack = () => setActiveStep((prev) => prev - 1);

	const handleSubmit = async () => {
		console.log("first");
		// Submit the form data to create a new scheme
		setLoadingOpen(true);
		try {
			await axios.post("/api/mbo_payment_working/save_discount_details", value).then((res) => {
				if (res.status === 201) {
					setSnackBarOpen(true);
					setSnackBar({
						...snackBar,
						message: "Discount Scheme created successfully",
						severity: "success",
						anchorOrigin: { horizontal: "center", vertical: "top" },
					});
					setLoadingOpen(false);
					setValue(initial_state);
				}
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `failed to create scheme ${error}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
			setValue(initial_state);
		}
	};

	console.log("Discount Master state", value);
	const renderStepContent = (step) => {
		switch (step) {
			case discountGroupObjects.general_information.group_no:
				return <MasterGeneralInformation value={value} setValue={setValue} />;
			case discountGroupObjects.applicable_date.group_no:
				return <ApplicableDate value={value} setValue={setValue} />;
			case discountGroupObjects.store_availability.group_no:
				return <StoreAvailabilitySection value={value} setValue={setValue} />;
			case discountGroupObjects.discount_value.group_no:
				return <DiscountValueSection value={value} setValue={setValue} />;
			case discountGroupObjects.product_selection.group_no:
				return <ProductSelectionSection value={value} setValue={setValue} />;
			default:
				return <Typography>Unknown step</Typography>;
		}
	};

	return (
		<Box width="100%" pt={4}>
			<Stepper activeStep={activeStep} alternativeLabel>
				{steps.map((label) => (
					<Step key={label}>
						<StepLabel>{label}</StepLabel>
					</Step>
				))}
			</Stepper>

			<Box mt={3} display={"flex"} alignItems={"center"} justifyContent={"center"} width={"100%"}>
				{renderStepContent(activeStep)}
			</Box>

			<Stack
				direction="row"
				spacing={2}
				justifyContent="space-between"
				mt={4}
				width={"93vw"}
				position={"fixed"}
				top="85%"
				left="6%">
				<Button disabled={activeStep === 0} onClick={handleBack}>
					Back
				</Button>
				{activeStep === steps.length - 1 ? (
					<Button variant="contained" onClick={handleSubmit}>
						Submit
					</Button>
				) : (
					<Button variant="contained" onClick={handleNext} disabled={activeStep === steps.length - 1}>
						Next{" "}
					</Button>
				)}
			</Stack>
		</Box>
	);
}

export default DiscountMaster;
